import {
  GET_ALL_MODEL_DETAILS,
  MODEL_IS_LOADING,
  UPDATE_MODEL_USER_SAVE_STATUS,
  MODEL_MANAGEMENT_ERROR,
  SET_MODEL_CURRENT_PAGE,
  SET_MODEL_PAGE_FILTER,
  SET_MODEL_DETAILS,
  SET_MODEL_DETAILS_DUPLICATE,
  SET_MODEL_CHANGE,
  SET_MODEL_FILTERED_RESULTS,
  MODEL_CLEANUP,
  GET_ALL_COMPONENT_POSITION_MODEL,
  SET_COMPONENT_POSITION_MODEL_FILTERED_RESULTS,
  COMPONENT_POSITION_MODEL_IS_LOADING,
  COMPONENT_POSITION_MODEL_MANAGEMENT_ERROR,
  UPDATE_COMPONENT_POSITION_MODEL_SAVE_STATUS,
  UPDATE_COMPONENT_POSITION_MODEL_SHOW_SCREEN,
  SET_COMPONENT_POSITION_MODEL_CHANGE,
  GET_ALL_MODELVARIANT_MODEL,
  SET_DUPLICATE_MODEL,
  UPLOAD_UNIT_COMPONENT_STATUS,
  GET_MODELSETPOINTS,
  MODELSETPOINTS_IS_LOADING,
  MODELSETPOINTS_MANAGEMENT_ERROR,
  MODELSETPOINTS_SET_CURRENT_PAGE,
  MODELSETPOINTS_SET_PAGE_FILTER,
  MODELSETPOINTS_SET,
  MODELSETPOINTS_UPDATE_SAVE_STATUS,
  MODELSETPOINTS_SET_CHANGE,
  UPDATE_MODELSETPOINTS_MODEL_SHOW_SCREEN,
  MODELSETPOINTS_SET_FILTERED_RESULTS,
  MODELSETPOINTS_CLEANUP,
  SET_MODEL_THRESHOLD_CURRENT_PAGE,
  SET_MODEL_THRESHOLD_PAGE_FILTER,
  MODEL_THRESHOLD_MANAGEMENT_ERROR,
  GET_ALL_MODEL_DETAILS_THRESHOLDS,
  MODEL_THRESHOLD_IS_LOADING,
  SET_MODEL_THRESHOLD_DETAILS,
  SET_MODEL_THRESHOLD_CHANGE,
  UPDATE_MODEL_THRESHOLD_SHOW_SCREEN,
  UPDATE_MODEL_THRESHOLD_SAVE_STATUS,
  UPDATE_MODEL_PERIODIC_SUMMARY_SETTINGS_SHOW_SCREEN,
  MODEL_PERIODIC_SUMMARY_SETTINGS_MANAGEMENT_ERROR,
  MODEL_PERIODIC_SUMMARY_SETTINGS_IS_LOADING,
  GET_ALL_MODEL_PERIODIC_SUMMARY_SETTINGS,
  SET_MODEL_PERIODIC_SUMMARY_SETTINGS_DETAILS,
  SET_MODEL_PERIODIC_SUMMARY_SETTINGS_CHANGE,
  UPDATE_MODEL_PERIODIC_SUMMARY_SETTINGS_SAVE_STATUS,
  MODELPERIODICSUMMARYSETTINGS_SET_FILTERED_RESULTS,
  MODELPERIODICSUMMARYSETTINGS_SET_PAGE_FILTER,
  MODELPERIODICSUMMARYSETTINGS_SET_CURRENT_PAGE,
  MODEL_SERVICE_PLANS_MANAGEMENT_ERROR,
  MODEL_SERVICE_PLANS_IS_LOADING,
  GET_ALL_MODEL_SERVICE_PLANS,
  SET_MODEL_SERVICE_PLANS_DETAILS,
  SET_MODEL_SERVICE_PLANS_CHANGE,
  UPDATE_MODEL_SERVICE_PLANS_SAVE_STATUS,
  UPDATE_MODEL_SERVICE_PLANS_SHOW_SCREEN,
  SERVICE_PLAN_SET_CURRENT_PAGE,
  SERVICE_PLAN_SET_PAGE_FILTER,
  SERVICE_PLAN_SET_FILTERED_RESULT
} from '../constants/index';
import { initialModelState } from './initialState';

const modelReducer = (state = initialModelState, action) => {
  const { payload, type } = action;
  switch (type) {
    case GET_ALL_MODEL_DETAILS: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          ...data
        }
      };
    }

    case SET_MODEL_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          currentPage
        }
      };
    }

    case SET_MODEL_PAGE_FILTER: {
      const { filter } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          filter
        }
      };
    }

    case UPDATE_MODEL_USER_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          ...data
        }
      };
    }

    case MODEL_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          isLoading: isLoading
        }
      };
    }

    case MODEL_MANAGEMENT_ERROR: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          ...data
        }
      };
    }

    case SET_MODEL_DETAILS: {
      let { modelDetails, ModelCategoryFilter, ModelCategoryOrganisations, ModelFilter } = payload;

      let modelData = modelDetails.length > 0 ? modelDetails[0] : state.modelManager.selectedModel;

      let ModelCategoryOrganisationsList = ModelCategoryOrganisations || [];
      ModelCategoryOrganisationsList.forEach(modelOrg => {
        if (modelOrg.IsProvisioned == 1) {
          modelOrg.IsSelected = true;
        }
        else {
          modelOrg.IsSelected = false;
        }
      });

      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          ModelCategoryFilter: ModelCategoryFilter || state.modelManager.ModelCategoryFilter,
          ModelFilter: ModelFilter || state.modelManager.ModelFilter,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ...modelData,
            ModelCategoryOrganisations: ModelCategoryOrganisationsList
          }
        },
        isLoading: false,
        showBanner: false,
        isOpSuccessful: true
      };
    }

    case SET_MODEL_CHANGE: {
      let { selectedModel } = payload;

      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: selectedModel
        },
        isLoading: false,
        showBanner: false,
        isOpSuccessful: true
      };
    }

    case SET_MODEL_DETAILS_DUPLICATE: {
      let { modelDetails } = payload;

      let modelData = modelDetails.length > 0 ? modelDetails[0] : state.modelManager.selectedModel;
      modelData.ModelId = 0;
      modelData.ModelName = modelData.Name;
      modelData.UpdatedBy = '';
      modelData.GuidIdentifier = '';
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ...modelData
          }
        },
        isLoading: false,
        showBanner: false,
        isOpSuccessful: true
      };
    }

    case SET_MODEL_FILTERED_RESULTS: {
      const { filteredResults } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          ...filteredResults
        }
      };
    }

    case MODEL_CLEANUP: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          ...data
        }
      };
    }

    // Component Positions -START
    //=========================

    case GET_ALL_COMPONENT_POSITION_MODEL: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ComponentPositionModel: {
              ...state.modelManager.selectedModel.ComponentPositionModel,
              ...data
            }
          }
        }
      };
    }
    case SET_COMPONENT_POSITION_MODEL_FILTERED_RESULTS: {
      const { filteredResults } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ComponentPositionModel: {
              ...state.modelManager.selectedModel.ComponentPositionModel,
              ...filteredResults
            }
          }
        }
      };
    }


    case COMPONENT_POSITION_MODEL_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ComponentPositionModel: {
              ...state.modelManager.selectedModel.ComponentPositionModel,
              isLoading: isLoading
            }
          }
        }
      };
    }

    case COMPONENT_POSITION_MODEL_MANAGEMENT_ERROR: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ComponentPositionModel: {
              ...state.modelManager.selectedModel.ComponentPositionModel,
              ...data
            }
          }
        }
      };
    }

    case UPDATE_COMPONENT_POSITION_MODEL_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ComponentPositionModel: {
              ...state.modelManager.selectedModel.ComponentPositionModel,
              ...data,
              filteredResults: data && data.componentPositionModels || state.modelManager.selectedModel.ComponentPositionModel.filteredResults
            }
          }
        }
      };
    }

    case SET_COMPONENT_POSITION_MODEL_CHANGE: {
      let { selectedcomponentPositionModel } = payload;

      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ComponentPositionModel: {
              ...state.modelManager.selectedModel.ComponentPositionModel,
              selectedcomponentPositionModel: {
                ...state.modelManager.selectedModel.ComponentPositionModel.selectedcomponentPositionModel,
                ...selectedcomponentPositionModel
              }
            }
          }
        }
      };
    }

    case UPDATE_COMPONENT_POSITION_MODEL_SHOW_SCREEN: {
      const { showAddEditScreen } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ComponentPositionModel: {
              ...state.modelManager.selectedModel.ComponentPositionModel,
              showAddEditScreen: showAddEditScreen
            }
          }
        }
      };
    }

    case GET_ALL_MODELVARIANT_MODEL: {
      const { data } = payload;

      data.ModelVariants.forEach(element => {
        element.RefModelVariantId = element.ModelVariantId;
        element.IsSelected = false;
        element.Setpoints = false;
        element.Thresholds = false;
      });

      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          isLoading: false,
          selectedModel: {
            ...state.modelManager.selectedModel,
            DuplicateModel: {
              ...state.modelManager.selectedModel.DuplicateModel,
              ...data
            }
          }
        }
      };
    }

    case SET_DUPLICATE_MODEL: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          isLoading: false,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ...data
          }
        }
      };
    }

    case UPLOAD_UNIT_COMPONENT_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ComponentPositionModel: {
              ...state.modelManager.selectedModel.ComponentPositionModel,
              ...data
            }
          }
        }
      };
    }

    // Component Positions - END
    //=========================


    //Model setpoints - START
    //=======================
    case GET_MODELSETPOINTS: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ModelSetpoints: {
              ...state.modelManager.selectedModel.ModelSetpoints,
              ...data,
              isDataPresent: true,
              isLoading: data.isLoading,
              redirect: false
            }
          },


        }
      };
    }

    case MODELSETPOINTS_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ModelSetpoints: {
              ...state.modelManager.selectedModel.ModelSetpoints,
              isLoading: isLoading
            }
          }
        }
      };
    }

    case MODELSETPOINTS_MANAGEMENT_ERROR: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ModelSetpoints: {
              ...state.modelManager.selectedModel.ModelSetpoints,
              ...data
            }
          }

        }
      };
    }

    case MODELSETPOINTS_SET_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ModelSetpoints: {
              ...state.modelManager.selectedModel.ModelSetpoints,
              currentPage: currentPage
            }
          }
        }
      };
    }

    case MODELSETPOINTS_SET_PAGE_FILTER: {
      const { filter } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ModelSetpoints: {
              ...state.modelManager.selectedModel.ModelSetpoints,
              filter: filter
            }
          }
        }
      };
    }

    case MODELSETPOINTS_UPDATE_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ModelSetpoints: {
              ...state.modelManager.selectedModel.ModelSetpoints,
              ...data

            }
          },
        }
      };
    }

    case MODELSETPOINTS_SET: {
      let { modelSetpoints } = payload;

      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ModelSetpoints: {
              ...state.modelManager.selectedModel.ModelSetpoints,
              selectedModelSetpoint: {
                ...state.modelManager.selectedModel.ModelSetpoints.selectedModelSetpoint,
                ...modelSetpoints.selectedModelSetpoint
              },
              isOpSuccessful: false,
              showBanner: false,
            }
          },


        }
      };
    }

    case MODELSETPOINTS_SET_CHANGE: {
      let { selectedModelSetpoint } = payload;

      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ModelSetpoints: {
              ...state.modelManager.selectedModel.ModelSetpoints,
              selectedModelSetpoint: {
                ...state.modelManager.selectedModel.ModelSetpoints.selectedModelSetpoint,
                ...selectedModelSetpoint
              },
              isOpSuccessful: false,
              showBanner: false,
              redirect: false,

            }

          }
        }
      }
    }

    case MODELSETPOINTS_SET_FILTERED_RESULTS: {
      const { filteredResults } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ModelSetpoints: {
              ...state.modelManager.selectedModel.ModelSetpoints,
              ...filteredResults
            }
          },

        }
      };
    }

    case MODELSETPOINTS_CLEANUP: {
      let { modelSetpoints } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ModelSetpoints: {
              ...modelSetpoints
            }
          }
        }
      };
    }

    case UPDATE_MODELSETPOINTS_MODEL_SHOW_SCREEN: {
      const { showAddEditScreen } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ModelSetpoints: {
              ...state.modelManager.selectedModel.ModelSetpoints,
              showAddEditScreen: showAddEditScreen
            }
          }
        }
      };
    }
    //Model setpoints - END
    //=======================

    /* 
    Model Thresholds - START
    =========================
    */

    case SET_MODEL_THRESHOLD_PAGE_FILTER: {
      const { filter } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            Thresholds: {
              ...state.modelManager.selectedModel.Thresholds,
              filter
            }
          }
        }
      };
    }

    case MODEL_THRESHOLD_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            Thresholds: {
              ...state.modelManager.selectedModel.Thresholds,
              isLoading: isLoading
            }
          }
        }
      };
    }

    case MODEL_THRESHOLD_MANAGEMENT_ERROR: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            Thresholds: {
              ...state.modelManager.selectedModel.Thresholds,
              ...data
            }
          }
        }
      };
    }

    case UPDATE_MODEL_THRESHOLD_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            Thresholds: {
              ...state.modelManager.selectedModel.Thresholds,
              ...data
            }
          }
        }
      };
    }

    case UPDATE_MODEL_THRESHOLD_SHOW_SCREEN: {
      const { showAddEditScreen } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            Thresholds: {
              ...state.modelManager.selectedModel.Thresholds,
              showAddEditScreen: showAddEditScreen
            }
          }
        }
      };
    }

    case SET_MODEL_THRESHOLD_DETAILS: {
      let { modelDetailThreshold } = payload;

      let modelThresholdsData =
        modelDetailThreshold.length > 0
          ? modelDetailThreshold[0]
          : state.modelManager.selectedModel.Thresholds.SelectedThreshold;

      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            Thresholds: {
              ...state.modelManager.selectedModel.Thresholds,
              SelectedThreshold: {
                ...state.modelManager.selectedModel.Thresholds.SelectedThreshold,
                ...modelThresholdsData
              }
            }
          }
        }
      };
    }

    case SET_MODEL_THRESHOLD_CHANGE: {
      let { SelectedThreshold } = payload;

      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            Thresholds: {
              ...state.modelManager.selectedModel.Thresholds,
              SelectedThreshold: {
                ...state.modelManager.selectedModel.Thresholds.SelectedThreshold,
                ...SelectedThreshold
              }
            }
          }
        }
      };
    }

    case SET_MODEL_THRESHOLD_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            Thresholds: {
              ...state.modelManager.selectedModel.Thresholds,
              currentPage: currentPage
            }
          }
        }
      };
    }

    case GET_ALL_MODEL_DETAILS_THRESHOLDS: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            Thresholds: {
              ...state.modelManager.selectedModel.Thresholds,
              ...data
            }
          }
        }
      };
    }
    /*
      Model Thresholds - END
    */


    //Model Periodic Summary Settings - START
    //======================================


    case MODEL_PERIODIC_SUMMARY_SETTINGS_MANAGEMENT_ERROR: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              ...data
            }
          }
        }
      };
    }

    case MODEL_PERIODIC_SUMMARY_SETTINGS_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              isLoading: isLoading
            }
          }
        }
      };
    }

    case GET_ALL_MODEL_PERIODIC_SUMMARY_SETTINGS: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              ...data
            }
          }
        }
      };
    }

    case SET_MODEL_PERIODIC_SUMMARY_SETTINGS_DETAILS: {
      let { periodicSummarySettings } = payload;

      let modelVariantPeriodicSummarySettingsData =
        periodicSummarySettings.length > 0
          ? periodicSummarySettings[0]
          : state.modelManager.selectedModel.PeriodicSummarySettings.SelectedPeriodicSummarySetting;

      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              SelectedPeriodicSummarySetting: {
                ...state.modelManager.selectedModel.PeriodicSummarySettings.SelectedPeriodicSummarySetting,
                ...modelVariantPeriodicSummarySettingsData
              }
            }
          }
        }
      };
    }

    case SET_MODEL_PERIODIC_SUMMARY_SETTINGS_CHANGE: {
      let { SelectedPeriodicSummarySetting } = payload;

      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              SelectedPeriodicSummarySetting: {
                ...state.modelManager.selectedModel.PeriodicSummarySettings.SelectedPeriodicSummarySetting,
                ...SelectedPeriodicSummarySetting
              }
            }
          }
        }
      };
    }

    case UPDATE_MODEL_PERIODIC_SUMMARY_SETTINGS_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              ...data
            }
          }
        }
      };
    }

    case UPDATE_MODEL_PERIODIC_SUMMARY_SETTINGS_SHOW_SCREEN: {
      const { showAddEditScreen } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              showAddEditScreen: showAddEditScreen
            }
          }
        }
      };
    }

    case MODELPERIODICSUMMARYSETTINGS_SET_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              currentPage: currentPage
            }
          }
        }
      };
    }

    case MODELPERIODICSUMMARYSETTINGS_SET_PAGE_FILTER: {
      const { filter } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              filter: filter
            }
          }
        }
      };
    }

    case MODELPERIODICSUMMARYSETTINGS_SET_FILTERED_RESULTS: {
      const { filteredResults } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              ...filteredResults
            }
          },

        }
      };
    }

    //Model Periodic Summary Settings - END
    //======================================

    //Model Service Plan START
    //=======================

    case GET_ALL_MODEL_SERVICE_PLANS: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ServicePlans: {
              ...state.modelManager.selectedModel.ServicePlans,
              ...data
            }
          }
        }
      };
    }

    case MODEL_SERVICE_PLANS_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ServicePlans: {
              ...state.modelManager.selectedModel.ServicePlans,
              isLoading: isLoading
            }
          }
        }
      };
    }

    case MODEL_SERVICE_PLANS_MANAGEMENT_ERROR: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ServicePlans: {
              ...state.modelManager.selectedModel.ServicePlans,
              ...data
            }
          }
        }
      };
    }

    case UPDATE_MODEL_SERVICE_PLANS_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ServicePlans: {
              ...state.modelManager.selectedModel.ServicePlans,
              ...data
            }
          }
        }
      };
    }

    case SET_MODEL_SERVICE_PLANS_DETAILS: {
      let { modelDetailsServicePlans } = payload;

      let modelServicePlansData =
        modelDetailsServicePlans.length > 0
          ? modelDetailsServicePlans[0]
          : state.modelManager.selectedModel.ServicePlans.SelectedServicePlan;

      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ServicePlans: {
              ...state.modelManager.selectedModel.ServicePlans,
              SelectedServicePlan: {
                ...state.modelManager.selectedModel.ServicePlans.SelectedServicePlan,
                ...modelServicePlansData
              }
            }
          }
        }
      };
    }

    case SET_MODEL_SERVICE_PLANS_CHANGE: {
      let { SelectedServicePlan } = payload;

      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ServicePlans: {
              ...state.modelManager.selectedModel.ServicePlans,
              SelectedServicePlan: {
                ...state.modelManager.selectedModel.ServicePlans.SelectedServicePlan,
                ...SelectedServicePlan
              }
            }
          }
        }
      };
    }

    case UPDATE_MODEL_SERVICE_PLANS_SHOW_SCREEN: {
      const { showAddEditScreen } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            ServicePlans: {
              ...state.modelManager.selectedModel.ServicePlans,
              showAddEditScreen: showAddEditScreen
            }
          }
        }
      };
    }


    case SERVICE_PLAN_SET_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              currentPage: currentPage
            }
          }
        }
      };
    }

    case SERVICE_PLAN_SET_PAGE_FILTER: {
      const { filter } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              filter: filter
            }
          }
        }
      };
    }

    case SERVICE_PLAN_SET_FILTERED_RESULT: {
      const { filteredResults } = payload;
      return {
        ...state,
        modelManager: {
          ...state.modelManager,
          selectedModel: {
            ...state.modelManager.selectedModel,
            PeriodicSummarySettings: {
              ...state.modelManager.selectedModel.PeriodicSummarySettings,
              ...filteredResults
            }
          },

        }
      };
    }
    // Model Service Plan END
    //=======================

    default:
      return state;
  }
};

export default modelReducer;
